import { defineComponent } from 'vue';
import { QBtn } from 'quasar';

function normalizeIconName(icon) {
    if (!icon)
        return 'mdi-circle-outline';
    const name = String(icon).replace(/^\s*mdi\s+/i, '').trim();
    return name || 'mdi-circle-outline';
}

const QUASAR_COLOR_NAMES = new Set([
    'primary', 'secondary', 'accent', 'positive', 'negative', 'info', 'warning',
    'white', 'black', 'blue', 'red', 'green', 'orange', 'pink', 'purple', 'teal', 'cyan', 'grey',
]);

function resolveButtonStyle(color) {
    if (!color || typeof color !== 'string')
        return undefined;
    const c = color.trim();
    if (QUASAR_COLOR_NAMES.has(c.toLowerCase()))
        return undefined;
    return { color: c };
}

function resolveButtonColor(color) {
    if (!color || typeof color !== 'string')
        return undefined;
    const c = color.trim();
    if (QUASAR_COLOR_NAMES.has(c.toLowerCase()))
        return c;
    return undefined;
}

export default defineComponent({
    name: 'FastGridDesignerActionCell',
    components: { QBtn },
    props: {
        params: { type: Object, default: null },
    },
    methods: {
        refresh(params) {
            this.params = params;
            return true;
        },
        onCommandClick(e, btn) {
            e.stopPropagation();
            e.preventDefault?.();
            this.gridComponent?.selectCommandButton(e, btn);
        },
        onAddCommandClick(e) {
            e.stopPropagation();
            e.preventDefault?.();
            this.gridComponent?.addCommandButton(e, this.columnDef);
        },
    },
    computed: {
        callcorp() {
            return this.params?.callcorp;
        },
        columnDef() {
            return this.callcorp?.columnDef;
        },
        gridComponent() {
            return this.callcorp?.gridComponent;
        },
        root() {
            return this.callcorp?.root;
        },
        selected$() {
            return this.gridComponent?.selected$;
        },
        firstrow() {
            return this.params?.node?.rowIndex === 0;
        },
        actionColumnEditing$() {
            if (!this.selected$ || !this.columnDef?.ActionOnlyColumn) return false;
            const m = this.root?.SelectedModel;
            if (!m) return false;
            if (m === this.columnDef) return true;
            const btns = this.columnDef.CommandButtons;
            return Array.isArray(btns) && btns.indexOf(m) >= 0;
        },
        commandButtons() {
            const cdef = this.columnDef;
            if (!cdef || !Array.isArray(cdef.CommandButtons))
                return [];
            return cdef.CommandButtons;
        },
    },
    render() {
        const items = [];
        for (let bi = 0; bi < this.commandButtons.length; bi++) {
            const btn = this.commandButtons[bi];
            const cmdSelected = this.root?.SelectedModel === btn;
            const iconName = normalizeIconName(btn.Icon);
            const quasarColor = resolveButtonColor(btn.Color);
            const colorStyle = resolveButtonStyle(btn.Color);

            items.push(
                <span
                    key={btn.$objectId || `cmd-${bi}`}
                    class={{ 'fast-grid-dsgn-cmd-btn': true, 'fast-grid-dsgn-cmd-btn--selected': cmdSelected }}
                    title="Edit command"
                    onClick={(e) => this.onCommandClick(e, btn)}>
                    <QBtn
                        flat
                        dense
                        round
                        size="sm"
                        class="q-mr-xs"
                        icon={iconName}
                        color={quasarColor}
                        style={colorStyle}
                        tabindex={-1}
                    />
                </span>
            );
        }

        let addCmd;
        if (this.firstrow && this.actionColumnEditing$ && this.gridComponent) {
            addCmd = (
                <QBtn
                    flat
                    dense
                    size="sm"
                    icon="mdi-plus-circle"
                    color="pink-9"
                    class="q-ml-xs"
                    title="Add command button"
                    tabindex={-1}
                    onClick={(e) => this.onAddCommandClick(e)}
                />
            );
        }

        return (
            <span
                class="fast-grid-dsgn-action-cell"
                style={{ display: 'inline-flex', alignItems: 'center', flexWrap: 'nowrap', whiteSpace: 'nowrap' }}
                onClick={(e) => e.stopPropagation()}>
                {items}
                {addCmd}
            </span>
        );
    },
});
